import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {
	TextField,
	Typography,
	Grid,
	Button,
	MenuItem,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	InputAdornment,
	IconButton
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { Card, FormGroup } from "reactstrap";
// import { IoMdSend } from "react-icons/io";
import FormControl from "@mui/material/FormControl";
import { getWalletAcRequired } from "../../../src/redux/actions/walletAcRequiredAction";
import { getIndividualEntity } from "../../../src/redux/actions/individualEntityActiion";
import { getDefaultCurrencyList } from "../../../src/redux/actions/adminCurrencyListAction";
// import PhoneInput from "react-phone-input-2";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SaveIcon from "@mui/icons-material/Save";
// import { IoIosArrowBack } from "react-icons/io";
import { countries } from "../../utils/countriesDropdown";
import val from "../../getThemeDetails";
import { useHistory } from "react-router-dom";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import success from "../../assets/img/success.png";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Visibility,VisibilityOff } from "@mui/icons-material";
import failed from "../../assets/img/failed.png";
import BackButton from "../../components/BackButton/BackButton";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
// import {
// 	MuiPickersUtilsProvider,
// 	DatePicker
// } from "@mui/material/pickers";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { divisionListPartner } from "../../redux/actions/divisionListPartnerAction";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { districtListPartner } from "../../redux/actions/districtListPartnerAction";
import { thanaListPartner } from "../../redux/actions/thanaListPartnerAction";
import { unionListPartner } from "../../redux/actions/unionListPartnerAction";

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";
 

const IndividualEntity = () => {
	const dispatch = useDispatch();
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const history = useHistory();
	const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	// const regenerateTokenRes = useSelector(
	// 	({ regenerateToken }) => regenerateToken
	// );
	// var authToken = regenerateTokenRes.data.AuthToken;


	const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
	var authToken = regenerateTokenRes.data.AuthToken;

	var LoginName = partnerloginUser.data.LoginName;
	var LoginRole = partnerloginUser.data.Role;
	const [individualEntityStatus, setIndividualEntityStatus] = useState(false);
	const [individualEntityRes, setindividualEntityRes] = useState("");
	const [hiddenPassword, setHiddenPassword] = useState("true");
	const [hiddenConPassword, setHiddenConPassword] = useState("true");
	const [divisionSetBool, setdivisionSetBool] = useState(false);
	const [divisionDropdownVal, setdivisionDropdownVal] = useState([]);
	const [districtSetBool, setdistrictSetBool] = useState(false);
	const [districtDropdownVal, setdistrictDropdownVal] = useState([]);
	const [thanaSetBool, setthanaSetBool] = useState(false);
	const [thanDropdownVal, setthanDropdownVal] = useState([]);
	const [unionsetBool, setunionsetBool] = useState(false);
	const [unionDropdownVal, setunionDropdownVal] = useState([]);
	// WalletACRequired

	const walletAcRequired = useSelector(
		({ walletAcRequired }) => walletAcRequired
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const divisionListPartnerRes = useSelector(({ divisionListPartner }) => divisionListPartner);
	const districtListPartnerRes = useSelector(({ districtListPartner }) => districtListPartner);
	const thanaListPartnerRes = useSelector(({ thanaListPartner }) => thanaListPartner);
	const unionListPartnerRes = useSelector(({ unionListPartner }) => unionListPartner);

	const setDivisionListFunc = () => {
		if (divisionSetBool) {
			if (divisionListPartnerRes.data.status === 'Success') {
				setdivisionDropdownVal(divisionListPartnerRes.data.list);
			}
			if (divisionListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", divisionListPartnerRes.data.description);
				if (
					divisionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					divisionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setDivisionListFunc();
	}, [divisionListPartnerRes.data.status]);

	const setDistrictListFunc = () => {
		if (districtSetBool) {
			if (districtListPartnerRes.data.status === 'Success') {
				setdistrictDropdownVal(districtListPartnerRes.data.list);
			}
			if (districtListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", districtListPartnerRes.data.description);
				if (
					districtListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					districtListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setDistrictListFunc();
	}, [districtListPartnerRes.data.status]);

	const setThanaListFunc = () => {
		if (thanaSetBool) {
			if (thanaListPartnerRes.data.status === 'Success') {
				setthanDropdownVal(thanaListPartnerRes.data.list);
			}
			if (thanaListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", thanaListPartnerRes.data.description);
				if (
					thanaListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					thanaListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setThanaListFunc();
	}, [thanaListPartnerRes.data.status]);

	const setUnionListFunc = () => {
		if (unionsetBool) {
			if (unionListPartnerRes.data.status === 'Success') {
				setunionDropdownVal(unionListPartnerRes.data.list);
			}
			if (unionListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", unionListPartnerRes.data.description);
				if (
					unionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					unionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setUnionListFunc()
	}, [unionListPartnerRes.data.status])

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const [user, setUser] = useState({
		customerEmail: "",
		userName: "",
		password: "",
		confirmPassword: "",
		role: "",
		firstName: "",
		lastName: "",
		// dob: "",
		gender: "",
		address: "",
		country: "",
		state: "",
		city: "",
		postalCode: "",
		phone: "",
		currency: ""
	});

	const {
		customerEmail,
		userName,
		password,
		confirmPassword,
		role,
		firstName,
		lastName,
		// dob,
		gender,
		address,
		country,
		state,
		city,
		postalCode,
		phone,
		currency,
		division,
		district,
		thana,
		union,
		stateInp
	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			obj[name] = value.trim()
			// obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}

		if (name === 'country') {
			obj.stateInp = '';
			obj.city = '';
			obj.postalCode = '';
			obj.division = '';
			obj.district = '';
			obj.thana = '';
			obj.union = '';
		}
		setUser(obj);
	};

	const IndividualEntityy = () => {
		setIndividualEntityStatus(true);
		const req = {
			loginDetails: {
				loginName: LoginName,
				loginRole: LoginRole,
				walletOwnerId: val.walletOwnerId
			},
			customerMasterDetailsRequestVO: {
				customerEmail: customerEmail,
				password: password,
				confPassword: confirmPassword,
				// accountType: "Merchant",
				accountType: role == "Select Role" ? "" : role,
				customerName: userName,
				firstName: firstName,
				lastName: lastName,
				dob: moment(selectedDate).format("DD/MM/YYYY"),
				gender: gender == "Select Gender" ? "" : gender,
				registeredAddress: address,
				country: country == "Select Country" ? "" : country,
				registeredCity: city,
				registeredState: state,
				registeredPostal: postalCode,
				mobile: phone,
				currency: currency == "Select Currency" ? "" : currency,
				division: division,
				district: district,
				thana: thana,
				union: union,
				selectedState: stateInp
			}
		};
		dispatch(getIndividualEntity(req, authToken));
	};

	const individualEntity = useSelector(
		({ individualEntity }) => individualEntity
	);

	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	// make change in file

	useEffect(() => {
		if (individualEntityStatus) {
			if (individualEntity.data.status == "Success") {
				setindividualEntityRes(individualEntity.data);
				setNotificationOpen(true);
				// swalWithBootstrapButtons.fire({
				//   type: "success",
				//   title: "IndividualEntity set Successfully",
				// });
			}
			if (individualEntity.data.status == "failed") {
				setindividualEntityRes(individualEntity.data);
				setNotificationOpen(true);
				if (
					individualEntity.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					individualEntity.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				// swalWithBootstrapButtons.fire({
				//   type: "error",
				//   title: "Something went Wrong",
				// });
			}
			if (individualEntity.data.status == "Failed") {
				setindividualEntityRes(individualEntity.data);
				setNotificationOpen(true);
				if (
					individualEntity.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					individualEntity.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				// swalWithBootstrapButtons.fire({
				//   type: "error",
				//   title: "Something went Wrong",
				// });
			}
		}
	}, [individualEntity.data.status]);

	// var descriptionn = individualEntity.data.result.description;

	const submitClick = (e) => {
		e.preventDefault();
		IndividualEntityy();

		// if (individualEntity.success) {
		//   swalWithBootstrapButtons.fire({
		//     type: "success",
		//     title: "IndividualEntity set Successfully",
		//   });
		//   IndividualE();
		// } else {
		//   swalWithBootstrapButtons.fire({
		//     type: "error",
		//     title: "Something went Wrong",
		//   });
		// }
	};

	const handleContact = (value, { dialCode, name, countryCode }) => {
		setUser((state) => ({
			...state,
			phoneNumber: value,
			countryCode: dialCode,
			//country: name,
			country: countryCode
		}));
	};

	const IndividualE = (id) => {
		// history.push({
		//   pathname: `/index/customer-master`,
		//   search: `?userId = ${id}`,
		// });
		history.push("/index/customer-master");
	};

	const togglePassword = (e) => {
		e.preventDefault();
		setHiddenPassword((state) => !state);
	};

	const toggleConPassword = (e) => {
		e.preventDefault();
		setHiddenConPassword((state) => !state);
	};

	useEffect(() => {
		if (country.includes('Bangladesh')) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId
				}
			}
			dispatch(divisionListPartner(req, authToken));
			setdivisionSetBool(true);
		}
	}, [country]);

	useEffect(() => {
		if (division) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: division
				}
			}
			dispatch(districtListPartner(req, authToken));
			setdistrictSetBool(true);
		}
	}, [division]);

	useEffect(() => {
		if (district) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: district
				}
			}
			dispatch(thanaListPartner(req, authToken));
			setthanaSetBool(true);
		}
	}, [district]);

	useEffect(() => {
		if (thana) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: district,
					thana: thana
				}
			}
			dispatch(unionListPartner(req, authToken));
			setunionsetBool(true);
		}
	}, [thana]);

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container>
						<Grid item lg={2} md={2}>
							{/* <Button
                onClick={IndividualE}
                startIcon={<IoIosArrowBack />}
                variant="text"
                color="primary"
              >
                Go Back
              </Button> */}
						</Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>

					{/* <hr /> */}
					<br />
					<Grid container>
						<Grid item xs={12} lg={12} md={12} sm={12}>
							<h6
								align="center"
								className="text-center themeText"
							// style={{ marginTop: "1.2rem", marginRight: "3rem" }}
							>
								{" "}
								Customer Information
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											type="email"
											required
											size="small"
											color="primary"
											label="Email"
											autoFocus={true}
											fullWidth={true}
											name="customerEmail"
											id="customerEmail"
											value={customerEmail}
											onChange={(e) => onInputChange(e)}
											variant="standard"
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
											type={hiddenPassword ? "password" : "text"}
											size="small"
											color="primary"
											autoFocus={true}
											label="Password"
											fullWidth={true}
											name="password"
											id="lastName"
											value={password}
											onChange={(e) => onInputChange(e)}
											
											variant="standard"
											error={
												(password.length > 0 && password.length < 8) ? (
													<p className="passwordNotMatch" style={{ color: "red" }}>
														{password.length > 0
															? "Password should be at least 8 characters"
															: ""}
													</p>
												) : (
													""
												)
											}

											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={togglePassword}
															onMouseDown={togglePassword}
														>
															{hiddenPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Should be same as Password)"
											type={hiddenConPassword ? "password" : "text"}
											size="small"
											color="primary"
											autoFocus={true}
											label="Confirm Password"
											fullWidth={true}
											name="confirmPassword"
											id="lastName"
											value={confirmPassword}
											onChange={(e) => onInputChange(e)}
											
											sx={{
												"& .MuiInput-underline:before": {
												  borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												  borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
												  borderBottomColor: "gray", // White color after focus
												},
											  }}
											variant="standard"
											error={
												password &&
													password !== confirmPassword &&
													confirmPassword ? (
													<p
														className="passwordNotMatch"
														style={{ color: "red" }}
													>
														{"Password did not match"}
													</p>
												) : (
													""
												)
											}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={toggleConPassword}
															onMouseDown={toggleConPassword}
														>
															{hiddenConPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Role"
									required
									fullWidth={true}
									name="role"
									// value={role}
									defaultValue={"Select Role" || role}
									onChange={(e) => onInputChange(e)}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
									variant="standard"
								>
									<MenuItem value="Select Role" selected="Select Role">
										Select Role
									</MenuItem>
									{walletAcRequired.success &&
										walletAcRequired.data.rolesList.map((x) => (
											<MenuItem value={x}>{x}</MenuItem>
										))}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									size="small"
									color="primary"
									label="Customer Name"
									fullWidth={true}
									name="userName"
									value={userName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									//error={!userName}
									helperText={"Customer name is required"}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									size="small"
									color="primary"
									label="First Name"
									fullWidth={true}
									name="firstName"
									value={firstName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									//error={!firstName}
									helperText={ "First name is required"}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									size="small"
									color="primary"
									label="Last Name"
									fullWidth={true}
									name="lastName"
									value={lastName}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									variant="standard"
									//error={!lastName}
									helperText={ "Last name is required" }
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								{/* <TextField
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="DOB"
                  fullWidth={true}
                  name="dob"
                  value={dob}
                  onChange={(e) => onInputChange(e)}
                ></TextField> */}
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<DatePicker
											label="DOB"
											format="MM/dd/yyyy"
											name="selectedDate"
											value={selectedDate}
											onChange={handleDateChange}
											disableFuture={true}
										/>
									 </LocalizationProvider>
								</FormControl>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									label="Gender"
									fullWidth={true}
									name="gender"
									// value={gender}
									defaultValue={"Select Gender" || gender}
									onChange={(e) => onInputChange(e)}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
									variant="standard"
								>
									{" "}
									<MenuItem value="Select Gender" selected="Select Gender">
										Select Gender
									</MenuItem>
									<MenuItem value="Male">Male</MenuItem>
									<MenuItem value="Female">Female</MenuItem>
									<MenuItem value="Other">Other</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									size="small"
									color="primary"
									label="Address"
									fullWidth={true}
									name="address"
									value={address}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "both")}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
									variant="standard"
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									type="string"
									label="Country"
									fullWidth={true}
									name="country"
									// value={country}
									defaultValue={"Select Country" || country}
									onChange={(e) => onInputChange(e)}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
									variant="standard"
								>
									<MenuItem value="Select Country" selected="Select Country">
										Select Country
									</MenuItem>
									{countries.map((value) => (
										<MenuItem value={value.label + value.dial_code}>
											{value.label}
										</MenuItem>
									))}
								</TextField>
							</div>
							{
								country.includes('Bangladesh') && (
									<>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Division"
												fullWidth={true}
												name="division"
												defaultValue={division || "Select Divison"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select Divison" selected="Select Divison">
													Select Division
												</MenuItem>
												{
													divisionDropdownVal && [].concat(divisionDropdownVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="District"
												fullWidth={true}
												name="district"
												defaultValue={district || "Select District"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select District" selected="Select District">
													Select District
												</MenuItem>
												{
													districtDropdownVal && [].concat(districtDropdownVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Thana"
												fullWidth={true}
												name="thana"
												defaultValue={thana || "Select thana"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select thana" selected="Select thana">
													Select thana
												</MenuItem>
												{
													thanDropdownVal && [].concat(thanDropdownVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>

										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												select
												type="text"
												size="small"
												color="primary"
												label="Union"
												fullWidth={true}
												name="union"
												defaultValue={union || "Select union"}
												onChange={(e) => onInputChange(e)}
												variant="standard"
											>
												<MenuItem value="Select union" selected="Select union">
													Select union
												</MenuItem>
												{
													unionDropdownVal && [].concat(unionDropdownVal).map(x => (
														<MenuItem value={x.name}>{x.name}</MenuItem>
													))
												}
											</TextField>
										</div>
									</>
								)
							}
							{
								country && !country.includes('Bangladesh') && (
									<>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="State"
												fullWidth={true}
												name="stateInp"
												value={stateInp}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
											/>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="City"
												fullWidth={true}
												name="city"
												value={city}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
											/>
										</div>

										<div style={{ marginTop: "1.5rem" }}>
											<TextField
												size="small"
												color="primary"
												label="Postal Code"
												fullWidth={true}
												name="postalCode"
												value={postalCode}
												// onChange={(e) => onInputChange(e)}
												onChange={(e) => onInputChange(e, "both")}
												variant="standard"
											/>
										</div>
									</>
								)
							}

							{/* <div style={{ marginTop: "1.5rem" }}>
                {" "}
                <Typography variant="body1" align="justify" gutterBottom={true}>
                  *Customer Phone.No:
                </Typography>
                <TextField
                  size="small"
                  color="primary"
                  autoFocus={true}
                  // label="phone"
                  variant="outlined"
                  fullWidth={true}
                  name="phone"
                  value={phone}
                  onChange={(e) => onInputChange(e)}
                />
                <PhoneInput
                  autoFormat={true}
                  enableSearch={true}
                  onChange={handleContact}
                  //onChange={(e) => onInputChange(e)}
                  value={phone}
                  onlyCountries={val.onlyCountries}
                />
              </div> */}

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									size="small"
									color="primary"
									label="Phone Number (with country code)"
									fullWidth={true}
									name="phone"
									value={phone}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									label="Currency"
									fullWidth={true}
									name="currency"
									// value={currency}
									defaultValue={"Select Currency" || currency}
									onChange={(e) => onInputChange(e)}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Currency" selected="Select Currency">
										Select Currency
									</MenuItem>
									{adminCurrencyList.success &&
										[]
											.concat(adminCurrencyList.data.currencyList)
											.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
								</TextField>
							</div>

							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								{/* <Button
                  style={{
                    // marginLeft: "0.7rem",
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  variant="contained"
                  // color="primary"
                  onClick={submitClick}
                  endIcon={<SaveIcon />}
                >
                  Submit
                </Button> */}

								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={submitClick}
									disabled = {!firstName || !lastName }
								>
									Submit <SaveIcon />
								</CustomButton>
							</div>
						</Grid>

						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>
			</Layout>

			{individualEntityRes.status == "Success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{individualEntityRes.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{individualEntityRes.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{individualEntityRes.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{individualEntityRes.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{individualEntityRes.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default IndividualEntity;
